<template>
    <div class="deliveryMap">
        <!-- <h5-header :header-msg="headerMsg"></h5-header> -->
        <baidu-map class="map" :scroll-wheel-zoom="true" :center="to" :zoom="zoom" @ready="handler">
            <bm-marker
                :position="to"
                :dragging="false"
                animation="BMAP_ANIMATION_BOUNCE"
                :zIndex="2"
                :icon="{url:`${prefixURL}/mobile/img/mp/icon_express_courier.png`, size: {width: 60, height: 66}}"
            ></bm-marker>
            <bm-marker
                :position="start"
                :dragging="false"
                animation="BMAP_ANIMATION_BOUNCE"
                :zIndex="0"
                :icon="{url:`${prefixURL}/mobile/img/mp/icon_express_shops.png`, size: {width: 60, height: 66}}"
            ></bm-marker>
            <bm-marker
                :position="end"
                :dragging="false"
                animation="BMAP_ANIMATION_BOUNCE"
                :zIndex="1"
                :icon="{url:`${prefixURL}/mobile/img/mp/icon_express_user.png`, size: {width: 60, height: 66}}"
            ></bm-marker>
        </baidu-map>
        <!-- 骑手相关信息 -->
        <div class="deliveryDetail">
            <div style="display:flex;align-items:center;" @click="callDelivery">
                <img src="../../assets/img/deliveryman-img.png" class="deliveryman-img" />
                <div class="deliveryman-name">
                    <span>顺丰骑士：</span>
                    <span v-text="deliveryName"></span>
                </div>
            </div>
            <div class="deliveryman-phone" @click="callDelivery">
                <a v-if="weChat" :href="'tel:'+ deliveryPhone">
                    <i class="iconfont icon-icon_map_call"></i>
                    <span>联系骑手</span>
                </a>
                <div v-else>
                    <i class="iconfont icon-icon_map_call"></i>
                    <span>联系骑手</span>
                </div>
            </div>
        </div>
        <!-- 刷新按钮 -->
        <div class="refresh" @click="getOrderRiderInfo">
            <i class="iconfont icon-icon_map_refresh"></i>
            <span>刷新</span>
        </div>
        <!-- 测试标签 -->
        <!-- <span class="test-tip">{{start}}</span> -->
    </div>
</template>

<script>
import { getOrderRiderInfo } from "@/api/join";
export default {
    data() {
        return {
            //     headerMsg: {
            //         title: "骑手位置",
            //         url: ""
            //     },
            imgUrl: this.imgPrex,
            prefixURL: this.prefixURL,
            // 骑手位置
            to: {
                lng: "",
                lat: ""
            },
            // 商家位置
            start: {
                lng: "",
                lat: ""
            },
            // 买家位置
            end: {
                lng: "",
                lat: ""
            },
            zoom: 15,
            orderId: "", // 传过来的订单ID
            deliveryName: "", // 骑手名字
            deliveryPhone: "", // 骑手电话
            weChat: "" // 判断是否在微信内打开
        };
    },
    created() {
        this.orderId = this.GetQueryString("orderId");
        this.getOrderRiderInfo();
        this.switchWechat();
    },
    mounted() {},
    methods: {
        handler({ BMap, map }) {
            this.map = map;
            this.BMap = BMap;
            // this.zoom = 14;
        },
        // 获取相关定位
        getOrderRiderInfo() {
            getOrderRiderInfo({ orderId: this.orderId }).then(res => {
                if (res.appStatus.errorCode == 0) {
                    let to = this.to,
                        start = this.start,
                        end = this.end;
                    to.lat = res.content.riderLat * 1;
                    to.lng = res.content.riderLng * 1;
                    start.lat = res.content.sellerLat * 1;
                    start.lng = res.content.sellerLng * 1;
                    end.lat = res.content.orderLat * 1;
                    end.lng = res.content.orderLat * 1;
                    this.zoom = 14;
                    this.deliveryName = res.content.riderName;
                    this.deliveryPhone = res.content.riderPhone;
                    // 点击刷新定位到骑手位置
                    this.map.setZoom(14);
                    const point = new this.BMap.Point(
                        res.content.riderLng,
                        res.content.riderLat
                    );
                    this.map.panTo(point);
                }
            });
        },
        // 联系骑手
        callDelivery() {
            let u = navigator.userAgent,
                app = navigator.appVersion;
            let isAndroid =
                u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            let isOS = isAndroid ? true : false;
            let deliveryPhone = this.deliveryPhone;
            if (isOS) {
                // Android环境
                window.Android.callDelivery(deliveryPhone);
            } else {
                // ios环境
                window.webkit.messageHandlers.callDelivery.postMessage(
                    this.deliveryPhone
                );
            }
        },
        // 处理App传过来的参数
        GetQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.href.split("?")[1].match(reg);
            if (r != null) return r[2];
            return null;
        },
        // 判断是否在微信小程序打开
        switchWechat() {
            let that = this;
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                wx.miniProgram.getEnv(res => {
                    if (res.miniprogram) {
                        that.weChat = true;
                    } else {
                        that.weChat = false;
                    }
                });
            } else {
                this.weChat = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.deliveryMap {
    height: 100vh;
    background-color: #fff;
    position: relative;
    .map {
        width: 100%;
        height: 100%;
    }
    .deliveryDetail {
        // width: calc(100% - 30px);
        width: 345px;
        height: 60px;
        // text-align: center;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        position: absolute;
        bottom: 10px;
        left: 0px;
        right: 0;
        margin: auto;
        background-color: #fff;
        .deliveryman-img {
            width: 40px;
            height: 40px;
        }
        .deliveryman-name {
            font-size: 14px;
            color: #1d1d1d;
            margin-left: 10px;
        }
        .deliveryman-phone {
            width: 87px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #187fe6;
            span {
                margin-left: 5px;
            }
            a {
                text-decoration: none;
                color: #187fe6;
            }
        }
    }
    .refresh {
        width: 40px;
        height: 40px;
        background: #fff;
        border-right: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #595959;
        font-size: 11px;
        position: absolute;
        top: 15px;
        right: 15px;
    }
}
.test-tip {
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 32px;
    color: red;
}
</style>